var takeover = {
	$this: $( '.js-take-over' ),
};

const $btnMenu = $( '.js-menu-btn' ),
	$closeBtn = $( '.js-close-btn' ),
	$scroller = $( '.js-take-over .scroller' ),
	$innerScroller = $( '.js-take-over .scroller .inner-scroller' ),
	$container = $( '.js-container' );

let setScrollTop = 0;

function open() {
	$innerScroller.removeAttr( 'style' );
	$( 'body' ).icons.init( '.svg-icon' );
	setScrollTop = $( window ).scrollTop();

	takeover.$this.css( 'visibility', 'visible' );
	setTimeout( function() {
		takeover.$this.addClass( 'show' );
	}, 10 );
	$closeBtn.addClass( 'show' );
	$( 'body' ).addClass( 'fixed' );
	$( 'body' ).css( 'overflow-y', 'hidden' );
	$container.addClass( 'fixed' ).css( { 'margin-top': -Math.abs( setScrollTop ) } );
}

function close() {
	$closeBtn.removeClass( 'show' );
	takeover.$this.removeClass( 'show' );
	setTimeout( function() {
		takeover.$this.removeAttr( 'style' );
	}, 300 );
	$( 'body' ).removeClass( 'fixed' );
	$( 'body' ).css( 'overflow-y', 'scroll' );
	$container.removeClass( 'fixed' ).removeAttr( 'style' );
	$( window ).scrollTop( setScrollTop );
}

function stickyFooter() {
	if ( Modernizr.mq( '(max-width: 1024px)' ) ) {

		var headerHeight = $( '.takeover-header' ).outerHeight(true),
				footerHeight = $( '.takeover-footer' ).outerHeight(true),
				contentHeight = $( '.takeover-content' ).outerHeight(true),
				contentNewHeight = $(window).height() - headerHeight - footerHeight - 100;

		setTimeout( function() {
			if ( contentHeight < contentNewHeight ) {
				$( '.takeover-content' ).css( 'min-height', contentNewHeight );
			}
		}, 100 );
	}
}

takeover.init = function() {
	$btnMenu.on( 'click', function( e ) {
		e.preventDefault();
		takeover.$this = $( '.js-take-over.menu-take-over' );
		stickyFooter();
		open();
	} );

	$closeBtn.on( 'click', function( e ) {
		e.preventDefault();
		close();
	} );

	$('.js-takeover-content .icon').on('click', function (e) {
		e.preventDefault();

		const $this = $(this),
			$item = $this.parents('.flexbox-item'),
			$submenu = $item.find('.sub-menu-outer'),
			submenuH = $submenu.children('ul').outerHeight(true);
		if ($this.hasClass('is-active')) {
			$this.removeClass('is-active');
			$item.removeClass('is-active');
			$submenu.addClass('is-open').css({ 'max-height': 0 })
		} else {
			$this.addClass('is-active');
			$item.addClass('is-active');
			$submenu.addClass('is-open').css({ 'max-height': submenuH });
		}

	});

	$('.js-submenu .current-menu-item .icon').click();
	$('.js-take-over .current-menu-item').parents('.sub-menu-outer').siblings('h4').children('.icon').click();

}

export { takeover };
